import classNames from 'classnames';

const CaretUp = ({ className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('icon', className)}
    role="presentation"
    aria-hidden={true}
  >
    <title>Up Caret</title>
    <g fillRule="evenodd">
      <path
        fill="currentColor"
        d="M17.2928929,15.7071062 C17.6834172,16.0976305 18.3165821,16.0976305 18.7071064,15.7071062 C19.0976307,15.3165819 19.0976307,14.683417 18.7071064,14.2928927 L12.7071064,8.29289268 C12.3165821,7.90236839 11.6834172,7.90236839 11.2928929,8.29289268 L5.29289286,14.2928927 C4.90236857,14.683417 4.90236857,15.3165819 5.29289286,15.7071062 C5.68341715,16.0976305 6.31658213,16.0976305 6.70710642,15.7071062 L11.9999996,10.414213 L17.2928929,15.7071062 Z"
      />
    </g>
  </svg>
);

CaretUp.propTypes = {
  className: PropTypes.string,
};

export default CaretUp;
